"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGestureOneFingerDrag(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm7.01752 7h-6.01752v-6h8v2.00165l.01611-.00165a1.97336 1.97336 0 0 1 .98389.26984v-3.26984h-10v8h7.01752z', opacity: 0.55 }),
        React.createElement("path", { d: 'm15.9997 10.1597a1.04935 1.04935 0 0 0 -1.0842-1.0153 1.02677 1.02677 0 0 0 -.9063.4907v-.0339a1.06344 1.06344 0 0 0 -1.0843-1.0322 1.05115 1.05115 0 0 0 -.9066.4739v-.0169a1.06327 1.06327 0 0 0 -1.0843-1.0323 1.05061 1.05061 0 0 0 -.9064.4738l-.0129.0182v-3.4857a.9986.9986 0 1 0 -1.9972 0v6.2814a.12083.12083 0 0 1 -.1276-.0355l-1.0675-1a1.08419 1.08419 0 0 0 -1.3431-.1148.99825.99825 0 0 0 -.4477.6886.9515.9515 0 0 0 .2411.7869l2.6345 3.0328a3.9415 3.9415 0 0 0 3.0133 1.3606h1.6357a3.47206 3.47206 0 0 0 2.4278-.9672 3.17516 3.17516 0 0 0 1.016-2.3115z' })));
}
exports.default = SvgGestureOneFingerDrag;
